import React from 'react'
import Slider from "react-slick";

const OurThesis = () => {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    return (
        <section className="silder-box">
            <div className="c15 fw500 df jcc " style={{ fontSize: '50px', lineHeight: '55.2px' }}> Our Thesis</div>
            {/* <AboutUsCrousel data={ABOUT_US_CONTENT} hasNoPadding={true} /> */}
            <Slider {...settings}>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis1-1.png")} alt="about-us-image1" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis2-1.png")} alt="about-us-image2" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis3-1.png")} alt="about-us-image3" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis4-1.png")} alt="about-us-image4" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis1-2.png")} alt="about-us-image1" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis2-2.png")} alt="about-us-image2" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis3-2.png")} alt="about-us-image3" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis4-2.png")} alt="about-us-image4" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis1-3.png")} alt="about-us-image1" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis2-3.png")} alt="about-us-image2" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis3-3.png")} alt="about-us-image3" />
                    </div>
                </div>
                <div>
                    <div className="img-slider-box">
                        <img src={require("../../../images/landingpage/thesis4-3.png")} alt="about-us-image4" />
                    </div>
                </div>
            </Slider>
            <div className="w100 df jcc fdc pr1rem pl1rem">
                <div className='w100 df jcc fw500 tac fs1rem' style={{ bottom: '6.5rem', color: "#FF8787", lineHeight: "2rem" }}>What portfolio improvement would you have achieved if you had avoided your worst investments?</div>
                <div className='w100 df jcc fw500 tac mb8rem fs1rem' style={{ color: "#FF8787" }}>Could better diligence improve your stats?</div>
            </div>
            <div className="bg1 aic" style={{ padding: "0rem 150px 0", textAlign: "center" }}>
                <p className="fw400 fs1-25rem c14 mb2rem tal" style={{ lineHeight: '2rem', letterSpacing: '0.055rem' }}>Even though their portfolio can come out ahead, <b>most</b> early-stage investors lose <b>most</b> of their investment on <b>most</b> of their investments. This is inefficient allocation of capital, and a waste of entrepreneurial blood, sweat and tears. Something we identify with!</p>
                <p className="fw400 fs1-25rem c14 mb2rem tal" style={{ lineHeight: '2rem', letterSpacing: '0.055rem' }}>… and ultimately reduces the pool of investment available to younger, smaller companies.</p>
                <p className="fw400 fs1-25rem c14 mb2rem tal" style={{ lineHeight: '2rem', letterSpacing: '0.055rem' }}>The founders of Diligentsia have been on both sides of this fence.  We think that whilst there are many elements of diligence that can’t be automated, there is a layer that can, and which can be used as part of a funnel – reducing failures and increasing efficiency and financial returns for everyone.</p>
                <p className="fw600 fs1-25rem c14 mb2rem tal" style={{ lineHeight: '2rem', letterSpacing: '0.055rem' }}>We invite you to come help us prove our thesis.</p>

            </div>
        </section>
    )
}

export default OurThesis